import React from 'react';
import T from 'prop-types';

// styles
import styles from './Placeholder.mod.css';

const Placeholder = ({ children }) => (
  <div className={styles.placeholder}>
    <h2>{children}</h2>
  </div>
);

Placeholder.propTypes = {
  children: T.string.isRequired
};

export default Placeholder;



// WEBPACK FOOTER //
// ./src/containers/Journal/components/Placeholder.jsx